export function TokenError(msg, code) {
    const err = Error(msg);
    err.code = code;
    return err;
}
